export default "__VITE_ASSET__BPGBZieN__"